import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const links = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Affiliate Disclosure', path: '/affiliate-disclosure' },
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms', path: '/terms' },
    { label: 'GDPR Policy', path: '/gdpr' },
    { label: 'Contact', path: '/contact' },
    { label: 'Sitemap', path: '/sitemap' }
  ];

  return (
    <footer className="border-t-2 border-[--border-color] bg-[--bg-secondary]">
      <div className="max-w-[1400px] mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Left Column */}
          <div className="md:col-span-3 space-y-6">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-[--text-primary] hover:text-[--accent] transition-colors"
            >
              <span role="img" aria-label="Orange" className="text-xl">🍊</span>
              <span className="text-xl font-bold tracking-tight">Lo-Fee.com</span>
            </Link>
            <div className="space-y-2">
              <div className="font-mono text-sm text-[--text-secondary]">
                Real-time Bitcoin exchange fee comparisons for Canadians.
              </div>
              <div className="font-mono text-xs text-[--text-secondary]">
                Data updates every 60s • All fees included • Prices in CAD
              </div>
            </div>
          </div>

          {/* Center Column */}
          <nav className="md:col-span-6">
            <div className="grid grid-cols-2 gap-8">
              <div className="space-y-4">
                <h3 className="text-sm font-bold uppercase tracking-wider text-[--text-secondary]">
                  Navigation
                </h3>
                <div className="space-y-3">
                  {links.slice(0, 4).map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className="block text-sm text-[--text-secondary] hover:text-[--accent] transition-colors"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </div>
              <div className="space-y-4">
                <h3 className="text-sm font-bold uppercase tracking-wider text-[--text-secondary]">
                  Legal
                </h3>
                <div className="space-y-3">
                  {links.slice(4).map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className="block text-sm text-[--text-secondary] hover:text-[--accent] transition-colors"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </nav>

          {/* Right Column */}
          <div className="md:col-span-3 space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-[--text-secondary]">
              Featured Partners
            </h3>
            <div className="space-y-3">
              {[
                { name: 'NDAX', url: 'https://refer.ndax.io/ebgT' },
                { name: 'Shakepay', url: 'https://shakepay.me/r/FM8INVL' },
                { name: 'Newton', url: 'https://web.newton.co/r/YASRDJ' }
              ].map((partner) => (
                <a
                  key={partner.name}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-[--text-secondary] hover:text-[--accent] transition-colors"
                >
                  {partner.name}
                  <ExternalLink className="h-3 w-3" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-[--border-color]">
          <div className="space-y-6">
            {/* Affiliate Disclaimer */}
            <div className="text-center">
              <span className="inline-block px-4 py-1 text-xs font-mono text-[--text-secondary] bg-[--bg-primary] border border-[--border-color]">
                AFFILIATE DISCLAIMER – We earn from qualifying purchases.
              </span>
            </div>

            {/* Copyright */}
            <div className="text-center text-sm text-[--text-secondary]">
              © {currentYear} Lo-Fee.com • All rights reserved
            </div>

            {/* Important Disclaimer */}
            <div className="max-w-3xl mx-auto text-[10px] leading-relaxed text-[--text-secondary] text-center opacity-75 font-mono">
              IMPORTANT DISCLAIMER: All content provided herein on our website, hyperlinked sites, associated applications, forums, blogs, social media accounts and other platforms ("Site") is for your general information only, procured from third-party sources. We make no warranties of any kind in relation to our content, including but not limited to accuracy and updatedness. No part of the content that we provide constitutes financial advice, legal advice, or any other form of advice meant for your specific reliance for any purpose. Any use or reliance on our content is solely at your own risk and discretion. You should conduct your own research, review, analyze, and verify our content before relying on them. Trading is a highly risky activity that can lead to major losses, please therefore consult your financial advisor before making any decision. No content on our Site is meant to be a solicitation or offer.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}